import { css } from 'linaria';
import { styled } from 'linaria/react';

export const sectionMarginHeight = 80;

export const CollectionBlock = styled.div`
  display: ${(props) => (props.hidden ? 'none' : 'block')};
`;

export const pdpSectionStyle = css`
  box-sizing: border-box;
  width: 1180px;
  margin-top: var(--space-300);
  margin-right: auto;
  margin-left: auto;
  background-color: var(--background-primary);
  transition: all 300ms ease-in-out;

  --collapsed-height: 320px;
  --max-content-height: 448px;
  --main-content-flex: 44 44 0;
  --side-content-flex: 15 15 0;

  @media screen and (min-width: 1024px) and (max-width: 1199px) {
    width: 940px;

    --collapsed-height: 320px;
    --max-content-height: 448px;
  }

  @media screen and (min-width: 768px) and (max-width: 1023px) {
    width: 100%;

    --collapsed-height: 320px;
    --max-content-height: 448px;
    --main-content-flex: 44 44 0;
    --side-content-flex: 15 15 0;
  }

  @media (--to-tablet) {
    width: 100%;
    margin-top: 0;

    /* turns out that measurement info tooltip prevent window from width calc */
    overflow: hidden;

    --collapsed-height: 360px;
    --max-content-height: 504px;
    --main-content-flex: 44 44 0;
    --side-content-flex: 15 15 0;
  }
`;

/* workaround to hide sections without content */
export const pdpSectionHideNoContent = css`
  &:not(:has([data-qa='products-carousel'])) {
    display: none !important;
  }
`;

export const pdpSectionSideContentStyle = css`
  padding-left: 70px;

  @media screen and (max-width: 1023px) and (min-width: 768px) {
    padding-left: 0;
    margin-top: 60px;
  }

  @media (--to-tablet) {
    padding-left: var(--space-200);
    margin-top: 40px;
  }
`;
